import styled from 'styled-components';

import {borderRadius, cardShadowCss} from 'styles/vars';

export const InstructionCover = styled.div`
  ${cardShadowCss(false)};
  background: #fff;
  border-radius: ${p => borderRadius[p.device]}px;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  height: 100%;
  left: 0;
  padding: ${p => (p.device === 'mobile' ? 1 : 2)}rem;
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const LastPublishedAt = styled.div`
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 12px;
`;
